import { useEffect } from "react";

export default function MailjetScript() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.mailjet.com/pas-nc-embedded-v1.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null;
}